import { Dto, DtoWithId } from "@mango/core";
import { User } from "src/app/user/user";
import { Relatie } from "./relatie";


@Dto({fullName: "CIJBorculo.Logic.RelatieUser"})
export class RelatieUser extends DtoWithId {
	relatie: Relatie;
	user: User;
}